export default "__VITE_ASSET__7e26f8da__"